import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import Social from "../../data/social";
import {getBlogs, getCMSAssets, getCMSGeneral} from "../../utils/cms.utils";

const FooterTwo = () => {
    const [general, setGeneral] = useState(null);
    const [blogs, setBlogs] = useState([]);
    const [assets, setAssets] = useState(null);

    /* ================= SUBSCRIBE STATE ================= */
    const [form, setForm] = useState({
        email: "",
        subject: "Saya telah Subscribe!",
        message: "Saya telah subscribe website PT. Raja Alam Raya",
    });

    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(null);

    /* ================= LOAD CMS ================= */
    useEffect(() => {
        setGeneral(getCMSGeneral());
        setBlogs(getBlogs());
        setAssets(getCMSAssets());
    }, []);

    const recentPosts = Array.isArray(blogs) ? blogs.slice(0, 2) : [];

    /* ================= SUBSCRIBE ================= */
    const handleChange = (e) => {
        setForm({...form, email: e.target.value});
    };

    const nameFromEmail = (email) => {
        if (!email) return "Subscriber Website";
        return email
            .split("@")[0]
            .replace(/[._-]+/g, " ")
            .replace(/\b\w/g, (c) => c.toUpperCase());
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.email) return;

        setLoading(true);
        setStatus(null);

        try {
            const api =
                process.env.NODE_ENV === "development"
                    ? "http://localhost:3000/api"
                    : "/api";

            const res = await fetch(`${api}/contact-us`, {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({
                    ...form,
                    name: nameFromEmail(form.email),
                }),
            });

            if (!res.ok) throw new Error(await res.text());

            setStatus("success");
            setForm({...form, email: ""});
        } catch (err) {
            console.error("SUBSCRIBE ERROR:", err);
            setStatus("error");
        } finally {
            setLoading(false);
        }
    };

    if (!general) return null;

    return (
        <>
            <div className="footer__two">

                {/* ================= SUBSCRIBE ================= */}
                <div className="subscribe__area">
                    <div className="container">
                        <div
                            className="row align-items-center subscribe__area-bg"
                            style={{backgroundImage: `url(${assets?.video_banner})`}}
                        >
                            <div className="col-lg-6 lg-mb-40 lg-t-center">
                                <div className="subscribe__area-left title_split_anim">
                                    <h2>Begin Your Dream Project Today!</h2>
                                </div>
                            </div>

                            <div className="col-lg-6">
                                <div className="subscribe__area-form mx-auto">
                                    <form onSubmit={handleSubmit}>
                                        <input
                                            type="email"
                                            placeholder="Email address"
                                            value={form.email}
                                            onChange={handleChange}
                                            disabled={loading}
                                        />
                                        <button
                                            className="build_button"
                                            type="submit"
                                            disabled={loading}
                                        >
                                            {loading
                                                ? "Subscribing..."
                                                : "Subscribe Now"}
                                        </button>
                                    </form>

                                    {status === "success" && (
                                        <p className="small mt-2">
                                            Thank you for subscribing.
                                        </p>
                                    )}

                                    {status === "error" && (
                                        <p className="small mt-2">
                                            Failed to subscribe. Please try again.
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ================= FOOTER CONTENT ================= */}
                <div className="container">
                    <div className="row">

                        {/* ===== ABOUT ===== */}
                        <div className="col-xl-4 col-lg-4 col-md-6">
                            <div className="footer__two-widget">
                                <div className="footer__two-widget-about text-center mx-auto">
                                    <Link to="/">
                                        <img
                                            src={general.logo2}
                                            alt={general.companyName}
                                        />
                                    </Link>

                                    {general.mottoId && (
                                        <p
                                            className="fst-italic"
                                            dangerouslySetInnerHTML={{
                                                __html: general.mottoId,
                                            }}
                                        />
                                    )}

                                    <div className="footer__two-widget-about-divider"/>

                                    <div className="footer__two-widget-about-social">
                                        <Social
                                            email={general.contact?.email}
                                            phone={general.contact?.phone}
                                            wa={general.contact?.wa}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* ===== OFFICE LOCATION ===== */}
                        <div className="col-xl-4 col-lg-4 col-md-6 md-mt-30">
                            <div className="footer__two-widget footer-border pl-60 md-pl-0">
                                <h4>Office Location</h4>

                                <div className="footer__two-widget-location">
                                    {general.contact?.office?.map(
                                        (office, index) => (
                                            <div key={index} className="footer__two-widget-location-item">
                                                <div className="footer__two-widget-location-item-icon">
                                                    <i className="flaticon-location"/>
                                                </div>

                                                <div
                                                    className={`footer__two-widget-location-item-info ${index > 0 ? "mt-4" : ""}`}>
                                                    <h6>{office.label}</h6>
                                                    <a
                                                        href={office.gmaps}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {office.address}
                                                    </a>
                                                </div>
                                            </div>
                                        )
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* ===== RECENT POST ===== */}
                        <div className="col-xl-4 col-lg-4 col-md-6 lg-mt-30">
                            <div className="footer__two-widget footer-border pl-60 lg-pl-0">
                                <h4>Recent Post</h4>

                                <div className="all__sidebar-item-post">
                                    {recentPosts.map((item) => (
                                        <div className="post__item" key={item.id}>
                                            <div className="post__item-title">

                                                {/* TAGS */}
                                                <span className="post__item-meta">
                <i className="far fa-calendar-alt"/>
                                                    {Array.isArray(item.tags) && item.tags.length > 0
                                                        ? item.tags.join(", ")
                                                        : "News"}
            </span>

                                                {/* TITLE */}
                                                <h6>
                                                    <Link to={`/blog/${item.id}`}>
                                                        {item.caption}
                                                    </Link>
                                                </h6>

                                            </div>
                                        </div>
                                    ))}


                                    {recentPosts.length === 0 && (
                                        <p className="small">
                                            No recent posts available.
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            {/* ================= COPYRIGHT ================= */}
            <div className="copyright__area">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="copyright__area-content t-center">
                                <p>
                                    Copyright 2026 – All Rights Reserved By
                                    <a
                                        href="https://rajaalamraya.com"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {" "}PT. Raja Alam Raya (RAR)
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default FooterTwo;
